package org.hs_soft.runmynesto.data.api_datasource.options.export

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.export.option_credit_card.OptionCreditCardModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.OptionCreditCardRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class OptionCreditCardRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
) : OptionCreditCardRepository {

    override suspend fun getOptionCreditCards(): OptionCreditCardModel {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
                query listCreditOptions {
                  ${ApiUtils.Field.cashAssist} {
                    ${ApiUtils.Field.getAppConfig} {
                      ${ApiUtils.Field.creditCards}
                      ${ApiUtils.Field.__typename}
                    }
                    ${ApiUtils.Field.__typename}
                  }
                }
            """.trimIndent())

            putJsonObject("variables") { }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }
} 